import { getActiveLanguage } from './homepageUrl';

export const getSearchLanguageRoot = (pathname, locale) =>
  `/${getActiveLanguage(pathname, locale)}`;

export const buildSearchUrl = (language, params = {}) => {
  const lang = language || 'ca';
  const query = new URLSearchParams(params).toString();
  return `/${lang}/search${query ? `?${query}` : ''}`;
};
